import type { ReactNode } from 'react';

export const symbol_screen_share: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M449-533h81v52q0 5.25 4.5 7.12 4.5 1.88 8.75-2.37l75.65-75.65q5.1-5.1 5.1-11.28T619-574l-75.74-75.74q-4.26-4.26-8.76-2.39-4.5 1.88-4.5 7.13v52h-81q-48.33 0-82.17 33.83Q333-525.33 333-477v60q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-60q0-23.8 16.1-39.9Q425.2-533 449-533ZM70-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-180 70-180h820q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H70Zm70-120q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h680q24 0 42 18t18 42v480q0 24-18 42t-42 18H140Zm0-60h680v-480H140v480Zm0 0v-480 480Z"
		/>
	</svg>
);
